export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11329.9c7ac79d.jpg";